export default "__VITE_ASSET__ac4cb32c__"